import fetch from 'cross-fetch';
import { actLoginTimedOut } from 'actions/loginStateActions';
import { actUploadFilesRecord } from 'actions/fileAction';
import {
  ISOURCE_INIT,
  ISOURCE_FORM_INIT,
  ISOURCE_CREATE_REQUEST_BEGIN,
  ISOURCE_CREATE_REQUEST_SUCCESS,
  ISOURCE_CREATE_REQUEST_FAIL,
  ISOURCE_CREATE_BUYER_REQUEST_BEGIN,
  ISOURCE_CREATE_BUYER_REQUEST_SUCCESS,
  ISOURCE_CREATE_BUYER_REQUEST_FAIL,
  ISOURCE_GET_LIST_BEGIN,
  ISOURCE_GET_LIST_SUCCESS,
  // ISOURCE_GET_LIST_FAIL,
  ISOURCE_GET_REQUEST_BEGIN,
  ISOURCE_GET_REQUEST_SUCCESS,
  ISOURCE_GET_REQUEST_FAIL,
  ISOURCE_SUPPLIER_SUBMIT_BEGIN,
  ISOURCE_SUPPLIER_SUBMI_SUCCESS,
  ISOURCE_SUPPLIER_SUBMI_FAIL,
} from './types';
import { ApiV1Base, ApiPrefix, json, statusCheck, getCookie } from '../../util/icwUtility';

export function actISourceInit() {
  return { type: ISOURCE_INIT };
}

export function actISourceFormInit() {
  return { type: ISOURCE_FORM_INIT };
}

// CREATE REQUEST

export function actISourceCreateRequestBegin() {
  return { type: ISOURCE_CREATE_REQUEST_BEGIN };
}

export function actISourceCreateRequestSuccess() {
  return { type: ISOURCE_CREATE_REQUEST_SUCCESS };
}

export function actISourceCreateRequestFail(error) {
  return { type: ISOURCE_CREATE_REQUEST_FAIL, payload: error };
}

export const actISourceCreateRequest = (filesDz, formData, companyId) => async (dispatch) => {
  const { files, path } = filesDz;

  actUploadFilesRecord(files, path).then((samplePhotos) => {
    const postData = {
      ...formData,
      samplePhotos,
    };

    fetch(`${ApiV1Base}${ApiPrefix}/iSources`, {
      method: 'POST',
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...postData,
        companyId,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json.success) {
          dispatch(actISourceCreateRequestSuccess());
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actISourceCreateRequestFail(typeof err === 'object' ? err.message : err));
      });
  });
};

// CREATE BUYER REQUEST

export function actISourceCreateBuyerRequestBegin() {
  return { type: ISOURCE_CREATE_BUYER_REQUEST_BEGIN };
}

export function actISourceCreateBuyerRequestSuccess() {
  return { type: ISOURCE_CREATE_BUYER_REQUEST_SUCCESS };
}

export function actISourceCreateBuyerRequestFail(error) {
  return { type: ISOURCE_CREATE_BUYER_REQUEST_FAIL, payload: error };
}

export const actISourceCreateBuyerRequest = (formData) => async (dispatch) => {
  fetch(`${ApiV1Base}${ApiPrefix}/iSources/buyingOrder`, {
    method: 'POST',
    body: JSON.stringify({
      ...formData,
    }),
    headers: {
      Authorization: getCookie('token'),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
    .then(statusCheck)
    .then(json)
    .then((json) => {
      if (json.success) {
        dispatch(actISourceCreateBuyerRequestSuccess());
      }
    })
    .catch((err) => {
      if (err.status === 401) {
        dispatch(actLoginTimedOut());
      }
      dispatch(actISourceCreateBuyerRequestFail(typeof err === 'object' ? err.message : err));
    });
};

export function actISourceGetListBegin() {
  return { type: ISOURCE_GET_LIST_BEGIN };
}

function actISourceGetListSuccess(data) {
  return { type: ISOURCE_GET_LIST_SUCCESS, data };
}

// function actISourceGetListFail(reason) {
//     return { type: ISOURCE_GET_LIST_FAIL, reason };
// };

export function actISourceGetList() {
  return (dispatch) => {
    dispatch(actISourceGetListBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/iSources`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((json) => dispatch(actISourceGetListSuccess(json)))
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actISourceCreateRequestFail(typeof err === 'object' ? err.message : err));
      });
  };
}

function actISourceGetRequestBegin() {
  return { type: ISOURCE_GET_REQUEST_BEGIN };
}

export function actISourceGetRequestSuccess(data) {
  return { type: ISOURCE_GET_REQUEST_SUCCESS, data };
}

function actISourceGetRequestFail(reason) {
  return { type: ISOURCE_GET_REQUEST_FAIL, reason };
}

export function actISourceGetRequest(id) {
  return (dispatch, getState) => {
    dispatch(actISourceGetRequestBegin());
    return fetch(`${ApiV1Base}${ApiPrefix}/iSources/${id}`, {
      headers: { Authorization: getCookie('token') },
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json.success) {
          dispatch(actISourceGetRequestSuccess(json));
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }

        dispatch(actISourceGetRequestFail(typeof err === 'object' ? err.message : err));
      });
  };
}

function actISourceSupplierSubmitBegin() {
  return { type: ISOURCE_SUPPLIER_SUBMIT_BEGIN };
}

export function actISourceSupplierSubmitSuccess(data) {
  return { type: ISOURCE_SUPPLIER_SUBMI_SUCCESS, data };
}

function actISourceSupplierSubmitFail(reason) {
  return { type: ISOURCE_SUPPLIER_SUBMI_FAIL, reason };
}

export const actISourceSupplierSubmit = (filesDz, formData) => async (dispatch) => {
  dispatch(actISourceSupplierSubmitBegin());
  const {
    brFiles,
    exportLicenseFiles,
    videos,
    productSpecFiles,
    productPhotos,
    productDocuments,
    path,
  } = filesDz;

  return Promise.all([
    actUploadFilesRecord(brFiles, path),
    actUploadFilesRecord(exportLicenseFiles, path),
    actUploadFilesRecord(videos, path),
    actUploadFilesRecord(productSpecFiles, path),
    actUploadFilesRecord(productPhotos, path),
    actUploadFilesRecord(productDocuments, path),
  ]).then((files) => {
    const br = files[0];
    const exportLicenses = files[1];
    const companyVideos = files[2];
    const productSpecFileResult = files[3];
    const productPhotos = files[4];
    const productDocuments = files[5];

    const postData = {
      ...formData,
      br,
      exportLicenses,
      companyVideos,
      productSpecFiles: productSpecFileResult,
      productPhotos,
      productDocuments,
    };

    fetch(`${ApiV1Base}${ApiPrefix}/iSources/subscribe`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...postData,
      }),
    })
      .then(statusCheck)
      .then(json)
      .then((json) => {
        if (json.success) {
          dispatch(actISourceSupplierSubmitSuccess());
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          dispatch(actLoginTimedOut());
        }
        dispatch(actISourceSupplierSubmitFail(typeof err === 'object' ? err.message : err));
      });
  });
};
